<template>
    <div class="target-item columns">
        <div class="column is-2"><button @click="deleteTarget">×</button></div>
        <div class="column is-10">{{ name }}</div>
    </div>
</template>

<script>
export default {
    name: "TargetItem",
    components: {
    },
    props: {
        'name': String,
    },
    data: function() {
        return {
        }
    },
    methods: {
        deleteTarget: function() {
            console.log(this.name);
            this.$emit('delete', this.name);
        }
    }
}
</script>

<style scoped>

.target-item {
    height: 60px;
}

</style>